import { Component, Ref, Prop } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

@Component
export class ImageMasonry extends ThemeComponent {

    @Prop({ default: false }) zoom!: boolean;

    init() {
        if (this.zoom) {
            this.initZoomGallery();
        }
    }

    initZoomGallery() {
        if (this.zoom) {
            const lightbox = new PhotoSwipeLightbox({
                gallery: this,
                children: 'a',
                pswpModule: () => import('photoswipe')
            });
            lightbox.init();
        }
    }

}
